import Head from "next/head";
import { FC } from "react";
import { useRouter } from "next/router";

const MainHeadWithTitle: FC<{ title?: string }> = ({ title }) => {
  const router = useRouter();
  const path = router.pathname;

  const pageTitles = {
    ["/hr"]: "Applicants",
    ["/hr/[slug]"]: "Terms",
    ["/hr/[slug]/form"]: "Applicant form",
    ["/hr/[slug]/[source]"]: "Applicant form",
  };

  return (
    <Head>
      {/* One viewport meta only — two separate name="viewport" tags made
          next/head drop both and fall back to its default (width=device-width
          with no initial-scale), which let iOS Safari auto-zoom on input focus
          and disabled the safe-area insets. initial-scale=1 + 16px inputs
          prevent the focus-zoom while keeping pinch-zoom for accessibility. */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, viewport-fit=cover"
      />

      <meta content="white" data-react-helmet="true" name="theme-color" />

      {title === `undefined undefined` ? (
        "Student"
      ) : (
        <title>
          {pageTitles[path as keyof typeof pageTitles] ||
            "Inter Nation English School"}
        </title>
      )}
    </Head>
  );
};

export default MainHeadWithTitle;
